module.exports = __webpack_public_path__ + "6c0026451db7f3198bbad63191ef28c0.svg";